module.exports = __webpack_public_path__ + "static/media/p3.c887798a.png";